<!-- <div class="modal-header">
  <h5 class="modal-title">Ladepark abonnieren</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <app-charging-park-subscription (newEntityEvent)="newEntityEvent($event)" #chargingParkSubscriptionComponent></app-charging-park-subscription>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-yellow" data-bs-dismiss="modal" (click)="onCancelClick()">Abbrechen</button>
  <form [formGroup]="this.formService.form" (ngSubmit)="chargingParkSubscriptionComponent.onSubmit(this.formService.form.value)">
    <button type="submit" class="btn btn-primary" [disabled]="!this.formService.form.valid">Abonnieren</button>
  </form>
</div> -->

<app-charging-park-subscription (newEntityEvent)="newEntityEvent($event)" #chargingParkSubscriptionComponent></app-charging-park-subscription>
